/**
 * Hatch pattern style strings for applying diagonal line backgrounds.
 *
 * Usage:
 *   import { hatchStyle45, hatchStyleNeg45 } from '#lib/styles/hatch.js';
 *   <section style={hatchStyle45}>
 *
 * The pattern creates evenly-spaced diagonal lines at 45 or -45 degrees.
 * Uses a soft gradient transition (not hard stops) for smoother anti-aliased rendering.
 */

/** 45-degree diagonal hatch pattern (top-left to bottom-right) */
export const hatchStyle45 =
	'background-image: repeating-linear-gradient(45deg, transparent 0, transparent 3.3px, rgba(0, 0, 0, 0.03) 3.5px, rgba(0, 0, 0, 0.08) 4px);';

/** -45-degree diagonal hatch pattern (top-right to bottom-left) */
export const hatchStyleNeg45 =
	'background-image: repeating-linear-gradient(-45deg, transparent 0, transparent 3.3px, rgba(0, 0, 0, 0.03) 3.5px, rgba(0, 0, 0, 0.08) 4px);';
